import { schema, t } from '@colyseus/schema';
export const PlayerSchema = schema({
    id: t.string(), nickname: t.string(), team: t.string(), characterId: t.string(),
    ready: t.boolean(), connected: t.boolean(), x: t.float32(), y: t.float32(), headOffsetY: t.float32(),
    vx: t.float32(), vy: t.float32(), facing: t.int8(), frozenUntil: t.float64(),
    campMs: t.float32(), skillReadyAt: t.float64(), skillActivatedAt: t.float64(),
    activeUntil: t.float64(), activeSkillId: t.string(),
    headHitAt: t.float64(), shotAt: t.float64(), rocketShotAt: t.float64(), hurtUntil: t.float64(),
    emote: t.string(), emoteUntil: t.float64(),
    score: t.uint8(),
});
export const GameStateSchema = schema({
    roomCode: t.string(), ownerId: t.string(), phase: t.string(),
    presetId: t.string(), durationSeconds: t.uint16(), goalLimit: t.uint8(),
    goldenGoal: t.boolean(), skillsEnabled: t.boolean(), friendlyCollision: t.boolean(),
    campingPenalty: t.boolean(), threePlayerTeam: t.string(),
    blueScore: t.uint16(), redScore: t.uint16(), remainingMs: t.float32(),
    bluePlayers: t.uint8(), redPlayers: t.uint8(), ballX: t.float32(), ballY: t.float32(),
    ballVx: t.float32(), ballVy: t.float32(), ballAngularVelocity: t.float32(), countdown: t.int8(), lastScorer: t.string(),
    winner: t.string(), serverTick: t.uint32(), players: t.map(PlayerSchema),
});
export const PlayerInputSchema = schema({
    moveX: t.int8(), jump: t.boolean(), shoot: t.boolean(), skill: t.boolean(),
});
